import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService, RouterState, RoutingService } from '@spartacus/core';
import { HamburgerMenuService } from '@spartacus/storefront';
import { WishlistService } from '@wishlist/feature';
import { Observable, combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'sd-wishlist-button',
  templateUrl: './wishlist-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WishlistButtonComponent implements OnInit {
  currentCount$: Observable<number>;
  isActive$: Observable<boolean>;

  constructor(
    private authService: AuthService,
    private wishlistService: WishlistService,
    private hamburgerMenuService: HamburgerMenuService,
    private routingService: RoutingService,
  ) {}

  ngOnInit(): void {
    this.currentCount$ = this.authService
      .isUserLoggedIn()
      .pipe(switchMap((isUserLoggedIn) => (isUserLoggedIn ? this.wishlistService.getEntriesCount() : of(0))));
    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      state: this.routingService.getRouterState().pipe(map((routerState: RouterState) => routerState.state)),
    }).pipe(map(({ isExpanded, state }) => !isExpanded && state.url.includes('/wishlist')));
  }
}
